export default __webpack_public_path__ + "images/logoMobile.57dffd9d6d2057cc4dd75c6997fcf9b9.svg";